import Swiper, {Navigation, Pagination, Thumbs, Grid, Autoplay, Zoom, Scrollbar} from "swiper";

// Создаем функцию инициализации слайдера с анимацией
export function initAllSliders() {
    if (document.querySelector('.home-slider')) {
        const activeSlide = document.querySelector('.home-slider-item-active');
        const activeWrapper = activeSlide.querySelector('.home-slider-item-active-wrapper');
        let currentActiveSlideInSwiper = null;
        let lastRealIndex = 0;
        const slides = document.querySelectorAll('.home-slider-list .swiper-slide');
        const totalSlides = slides.length; // Количество слайдов
        let autoSlideInterval = null;
        let userInteracted = false; // Флаг для остановки авто-прокрутки при взаимодействии

        const overlayImage = document.createElement('div');
        overlayImage.className = 'slider-overlay';
        activeSlide.insertBefore(overlayImage, activeWrapper);

        function updateActiveSlide(slide, direction = 'next') {
            if (!slide) return; // Защита от undefined

            const slideImage = slide.dataset.image || '';
            const slideTitle = slide.dataset.title || '';
            const slideText = slide.dataset.text || '';
            const slideDate = slide.dataset.date || '';
            const slideLink = slide.dataset.link || '#';

            // Обновляем изображение, текст и другие элементы слайда
            overlayImage.style.backgroundImage = `url(${slideImage})`;
            overlayImage.className = 'slider-overlay';
            overlayImage.classList.add(`slide-in-${direction}`);

            activeWrapper.classList.add('fade-out');

            setTimeout(() => {
                activeSlide.querySelector('.home-slider-item-active-image').src = slideImage;
                activeSlide.querySelector('.app-news-date').innerHTML = slideDate;
                activeSlide.querySelector('.app-news-title').textContent = slideTitle;
                activeSlide.querySelector('.app-news-text').textContent = slideText;
                document.querySelector('.app-news-link').href = slideLink;

                // Обновление data-slide
                document.querySelector('.app-news-link').setAttribute('data-slide', slide.dataset.slide);

                overlayImage.classList.remove(`slide-in-${direction}`);
                activeWrapper.classList.remove('fade-out');
                activeWrapper.classList.add('fade-in');

                currentActiveSlideInSwiper = slide;

                setTimeout(() => {
                    activeWrapper.classList.remove('fade-in');
                }, 300);
            }, 300);
        }

        const homeSlider = new Swiper(".home-slider-swiper", {
            modules: [Pagination, Navigation, Grid, Scrollbar],
            slidesPerView: 1,
            spaceBetween: 10,
            grabCursor: true,
            watchSlidesProgress: true,
            autoplay: false,
            loop: false, // Выключаем зацикливание
            scrollbar: {
                el: '.home-slider-swiper .swiper-scrollbar',
            },
            pagination: {
                el: '.home-slider-swiper .swiper-pagination',
                clickable: true,
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    let bullets = "";
                    for (let i = 0; i < swiper.slides.length; i++) {
                        const activeClass = swiper.activeIndex === i ? "swiper-pagination-bullet-active" : "";
                        bullets += `<span class="swiper-pagination-bullet ${activeClass}" data-index="${i}"></span>`;
                    }
                    return bullets;
                }
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.4,
                    spaceBetween: 10,
                },
                576: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                }
            },
            on: {
                click: function (swiper, event) {
                    stopAutoSlide();
                    userInteracted = true;

                    const clickedSlide = event.target.closest('.swiper-slide');
                    if (!clickedSlide || clickedSlide === currentActiveSlideInSwiper) return;

                    const clickedIndex = [...swiper.slides].indexOf(clickedSlide);
                    const direction = clickedIndex > lastRealIndex ? 'next' : 'prev';

                    updateActiveSlide(clickedSlide, direction);
                    lastRealIndex = clickedIndex;
                },
                slideChange: function (swiper) {

                },
                slideChangeTransitionEnd: function (swiper) {
                    // Обновляем пагинацию на каждом изменении слайда
                    updatePagination(swiper);
                }
            }
        });

        function updatePagination(swiper) {
            const bullets = document.querySelectorAll('.home-slider-swiper .swiper-pagination-bullet');
            bullets.forEach((bullet, index) => {
                // Обновляем класс активности на основе realIndex
                bullet.classList.toggle('swiper-pagination-bullet-active', index === swiper.realIndex);
            });
        }

        document.querySelector('.home-slider-swiper .swiper-pagination').addEventListener('click', function (e) {
            if (e.target.classList.contains('swiper-pagination-bullet')) {
                const index = parseInt(e.target.getAttribute('data-index'));
                homeSlider.slideTo(index);
                updateActiveSlide(slides[index], 'next'); // Обновляем app-news-link при клике на точку
                lastRealIndex = index;

                // Если автопрокрутка была остановлена, запускаем ее заново
                if (!userInteracted) {
                    startAutoSlide();
                }
            }
        });

        // Функция для начала автопрокрутки
        function startAutoSlide() {
            if (autoSlideInterval) clearInterval(autoSlideInterval);
            userInteracted = false;

            autoSlideInterval = setInterval(() => {
                if (userInteracted) return;

                let nextIndex = lastRealIndex + 1;

                // Остановка автопрокрутки, если достигнут последний слайд
                if (nextIndex >= totalSlides) {
                    stopAutoSlide();
                    return;
                }

                // Листаем на следующий слайд
                let nextSlide = slides[nextIndex];

                // Обновляем слайд
                updateActiveSlide(nextSlide, 'next');
                homeSlider.slideTo(nextIndex);
                lastRealIndex = nextIndex;
            }, 5000); // Каждые 2 секунды
        }

        // Функция для остановки автопрокрутки
        function stopAutoSlide() {
            userInteracted = true;
            if (autoSlideInterval) {
                clearInterval(autoSlideInterval);
                autoSlideInterval = null;
            }
        }

        // Запуск автопрокрутки
        startAutoSlide();

        // Обработчик изменения размера экрана
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 576 && currentActiveSlideInSwiper && !userInteracted) {
                updateActiveSlide(currentActiveSlideInSwiper, 'next');
                startAutoSlide();
            }
        });
    }

    new Swiper(".home-video-news-swiper", {
        modules: [Pagination, Navigation, Grid, Autoplay, Scrollbar],
        slidesPerView: 1.1,
        spaceBetween: 10,
        initialSlide: 0,
        breakpoints: {
            576: {
                slidesPerView: 1.5,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1500: {
                slidesPerView: 2,
                spaceBetween: 30,
            }
        },
    });
    new Swiper(".home-partners-swiper", {
        modules: [Pagination, Navigation, Grid, Autoplay, Scrollbar],
        slidesPerView: 1.4,
        spaceBetween: 10,
        grabCursor: true,
        navigation: {
            nextEl: ".swiper-btn-next",
            prevEl: ".swiper-btn-prev",
        },
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1500: {
                slidesPerView: 4,
                spaceBetween: 30,
            }
        },
    });
}